import React from 'react';
import SVG from "react-inlinesvg";
import {Modal} from "react-bootstrap";
import {toAbsoluteUrl} from "../../../../../../../_metronic/_helpers";
import ErrorMessage from './ErrorMessage';


const CreateBank = ({show, action: {action, error, data}, onHide}) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <SVG
                            title=""
                            src={toAbsoluteUrl("/media/svg/icons/General/Unlock.svg")}/>
                        />
                    </span> {action}
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body
                className="px-10 py-2"
            >
                <ErrorMessage {...{error}} />
                <div className="row">
                    <div className="col-lg py-4">
                        <h6 className=" px">Bank Name</h6>
                        <span className="text-muted">{data?.bankName}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Country</h6>
                        <span className="text-muted">{data?.country}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Currency</h6>
                        <span className="text-muted">{data?.currency}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6 className=" px">Flutterwave Code</h6>
                        <span className="text-muted">{data?.flutterwaveCode}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Monnify Code</h6>
                        <span className="text-muted">{data?.monnifyCode}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Paystack Code</h6>
                        <span className="text-muted">{data?.paystackCode}</span>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <button
                    type="button"
                    onClick={onHide}
                    className="btn btn-primary btn-elevate px-5"
                >
                    Okay
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export default CreateBank;